import { tryFetch } from '@/services/http'
import { HttpMethod } from '@/services/http/types/http.enums'
import type { Search, SearchResponse } from '../interfaces/search'

const BASE_URL = import.meta.env.VITE_MAIN_BASE_URL

const getSearchResult = async (body: Search): Promise<{ data?: SearchResponse; error?: any; status: number }> =>
  await tryFetch(HttpMethod.Post, BASE_URL, 'search', { view: true, body })

export const searchApi = {
  getSearchResult,
}
